
import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Form, Button } from 'react-bootstrap';
import withRouter from '../../common/WithRouter';
import { useNavigate } from 'react-router-dom';
import { Formik, Field } from 'formik';
import { LoginValidationSchema } from 'src/validations/validationSchemas';
import { useForgetPassword } from 'src/services/auth.service';
import { toast, ToastContainer } from 'react-toastify';
import * as Yup from "yup";


function SignIn(props) {
    const navigate = useNavigate();
    const { mutateAsync: forgetPassword } = useForgetPassword();

    const [rememberMe, setRememberMe] = useState(false);
    const [initialValues, setInitialValues] = useState({
        emailOrPhoneNumber: "",

    });

    const ReseatValidationSchema = Yup.object().shape({
        emailOrPhoneNumber: Yup.string().required("Email is required"),
        // .email("Enter a valid email address")

    });

    // Load remembered credentials
    useEffect(() => {

        const body = document.querySelector('body');
        body.classList.add('loaded');

        return () => {
            body.classList.remove('loaded');
        };
    }, []);

    const handleSubmitForm = async (values, { setSubmitting }) => {
        try {
            const res = await forgetPassword(values);

            if (res?.status === 200) {

                toast(res?.data?.message, {
                    containerId: "default",
                    className: "no-icon notification-success",
                });

                localStorage.setItem(
                    "passwordResetCredentials",
                    JSON.stringify({
                        emailOrPhoneNumber: values.emailOrPhoneNumber,

                    })
                );

                navigate("/verify-otp")

            } else {
                toast(res?.data?.message, {
                    containerId: "default",
                    className: "no-icon notification-danger",
                });
            }
        } catch (error) {
            toast(error?.response?.data?.message, {
                containerId: "default",
                className: "no-icon notification-danger",
            });
        }

        setSubmitting(false);
    };



    return (
        <section className="body-sign">
            <div className="center-sign">
                <Card className="card-sign">
                    <Card.Body>
                        <h2 className="sign-title">Verify Email</h2>


                        <Formik
                            enableReinitialize
                            initialValues={initialValues}
                            validationSchema={ReseatValidationSchema}
                            onSubmit={handleSubmitForm}
                        >
                            {({ errors, touched, handleChange, values, handleSubmit, isSubmitting }) => (
                                <Form onSubmit={handleSubmit}>

                                    {/* Email */}
                                    <Form.Group className="form-custom-group">
                                        <Form.Label>
                                            Email Address <span className="required">*</span>
                                        </Form.Label>

                                        <Field
                                            as={Form.Control}
                                            type="text"
                                            name="emailOrPhoneNumber"
                                            value={values.emailOrPhoneNumber}
                                            onChange={handleChange}
                                            className={
                                                errors.emailOrPhoneNumber && touched.emailOrPhoneNumber
                                                    ? "is-invalid"
                                                    : ""
                                            }
                                        />

                                        {errors.emailOrPhoneNumber && touched.emailOrPhoneNumber && (
                                            <p style={{ color: "red" }}>
                                                {errors.emailOrPhoneNumber}
                                            </p>
                                        )}
                                    </Form.Group>


                                    {/* Submit */}
                                    <button
                                        type="submit"
                                        // className="btn-login mt-3"
                                        className='btn-black'
                                        style={{ width: "100%", marginBottom: "10px" }}
                                        block
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? 'Submiting...' : 'Submit'}
                                    </button>

                                </Form>
                            )}
                        </Formik>

                        <span style={{ cursor: "pointer" }} > Sign in  </span>


                    </Card.Body>
                </Card>
            </div>

            <ToastContainer
                className="ui-pnotify"
                closeButton={false}
                closeOnClick={false}
                draggable={false}
                position="top-right"
                hideProgressBar={true}
                autoClose={3000}
                containerId="default"
                enableMultiContainer={true}
            />
        </section>
    );
}

export default React.memo(withRouter(SignIn));
